<template lang="pug">
  .wrap
    h1 ¿Cómo hicimos este trabajo?
    p Transición es un proyecto digital de La Tercera (y su marca Qué Pasa) que comenzó a ejecutarse en julio de 2018. Un grupo de alrededor de 15 personas de diferentes equipos del diario (La Tercera TV, diseño e infografías, foto y desarrollo web) trabajaron durante cuatro meses bajo la coordinación de la investigadora de este especial, la periodista Tania Opazo.
    p A fines de octubre, ad portas de su lanzamiento y con el apoyo del Laboratorio de Contenidos de Marca de La Tercera, Transición consigue el auspicio de Wom, empresa que apostó a este proyecto periodístico respetando completamente la libertad e independencia editorial del mismo. Transición se transforma así en el primer producto digital, 100% editorial, de La Tercera, en conseguir el financiamiento de una empresa privada para su realización.

</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
  .wrap{
    text-align: center;
    padding: 2rem 1rem;
    max-width: $maxwidth;
    margin-left: auto;
    margin-right: auto;
  }

</style>


